/**
 * Created by claudenbach on 2/7/2017.
 */

import { LMEditorService } from './lm-editor.service';

export const isCheckControlEditable = (
  lmEditorService: LMEditorService,
  row: number,
  cell: number,
  value: any,
  columnDef: ListGridColumn,
  dataView: LMListDataView,
  dataGrid: SohoDataGridStatic
): boolean  => {

  let isCheckActionValid = false;
  let isUncheckActionValid = false;

  if (!dataView || dataView.isTreeMoreLink) {
    return;
  }

  if (columnDef.displayField.validity && columnDef.displayField.checkActions && columnDef.displayField.uncheckActions) {
    let len = columnDef.displayField.checkActions.length;
    for (let i = 0; i < len; i++) {
      const checkAction = columnDef.displayField.checkActions[i];

      /*
       * The rule of thumb is to always take the first valid action. If
       * there is no when condition on the first check action then
       * pick that one and make it valid.
       */
      if (checkAction.condition) {
        isCheckActionValid = lmEditorService.isConditionValid([checkAction.condition], dataView);
      } else {
        isCheckActionValid = true;
      }

      if (isCheckActionValid) {
        if (!columnDef.displayField.checkAction) {
          columnDef.displayField.checkAction = [];
        }

        columnDef.displayField.checkAction[row] = checkAction;
        break;
      }
    }

    len = columnDef.displayField.uncheckActions.length;
    for (let i = 0; i < len; i++) {
      const uncheckAction = columnDef.displayField.uncheckActions[i];
      if (uncheckAction.condition) {
        isUncheckActionValid = lmEditorService.isConditionValid([uncheckAction.condition], dataView);
      } else {
        isUncheckActionValid = true;
      }

      if (isUncheckActionValid) {
        if (!columnDef.displayField.uncheckAction) {
          columnDef.displayField.uncheckAction = [];
        }

        columnDef.displayField.uncheckAction[row] = uncheckAction;
        break;
      }
    }
  }

  if (!dataView.fields[columnDef.displayField.fieldId].value && !isCheckActionValid
  ||   dataView.fields[columnDef.displayField.fieldId].value && !isUncheckActionValid) {
    return false; // is ReadOnly
  } else {
    return true; // is editable
  }
};
